import { tienePermiso } from '../../../utils/permisosUtil';

export const permisosImportarDatosMixin = {
  computed: {
    permisosImportarDatos() {
      return {
        accesoModulo: tienePermiso('importData'),
      };
    },
  },
};
